import injectScript from '@gumtree/ui-library/src/utils/inject-script';
// import { WindowWithCmp } from '../gdpr/util';

// const getOnetrustActiveGroups = () => {
//     if (!window.gumtreeDataLayer) return '';
//     // 倒序查找，取最近一次
//     for (let i = window.gumtreeDataLayer.length - 1; i >= 0; i--) {
//         const item = window.gumtreeDataLayer[i];
//         if (item && item.event === 'OneTrustGroupsUpdated' && item.OnetrustActiveGroups) {
//             return item.OnetrustActiveGroups;
//         }
//     }
//     return '';
// }

export const addDurationMedia = (window) => {
    if (window) {
        if (window.durationMediaScriptLoaded) return;
        window.durationMediaScriptLoaded = true;
        // const type = window?.clientData?.page?.type;    
        // type这个type和Tag Manager中的不一致，如果要平移逻辑就需要逐个确认替换
        // const typeRe = /^(Homepage|ResultsBrowse|ResultsSearch|VIP|eVIP|pVIP|LandingPage\w*|UserStatic|MyAds|ResultsSeller\w*)$/i;
        // const groups = getOnetrustActiveGroups();
        // const groupRe = /,(C0002|STACK42),/;
        // const hostname = window.location.hostname;
        // const hostRe = /gumtree\.com$/i;

        // if (type && typeRe.test(type) && groupRe.test(groups) && hostRe.test(hostname)) {
        //     injectScript('//tag.durationmedia.net/sites/11542/dm.js', { async: true, id: 'dm-script' });
        // }

        // Tag Manager has some limits, there is no need to shift the limits. confirmed with Efe.

        injectScript('//tag.durationmedia.net/sites/11542/dm.js', { async: true, id: 'dm-script' });
    }
};
